// Enhanced Intersection Observer for modern scroll animations
const observerOptions = {
    root: null,
    rootMargin: '100px',
    threshold: 0.15
};

// Main section observer
const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const section = entry.target;
            
            // Add animation class
            section.classList.add('animate-up');
            
            // Animate stat cards if present
            const statCards = section.querySelectorAll('.stat-card');
            statCards.forEach((card, index) => {
                setTimeout(() => {
                    card.classList.add('animate');
                }, index * 200);
            });
            
            // Animate project cards with stagger
            const projectCards = section.querySelectorAll('.project-card');
            projectCards.forEach((card, index) => {
                setTimeout(() => {
                    card.style.opacity = '1';
                    card.style.transform = 'translateY(0)';
                }, index * 150);
            });
            
            // Animate text cards with stagger
            const textCards = section.querySelectorAll('.text-card');
            textCards.forEach((card, index) => {
                setTimeout(() => {
                    card.style.opacity = '1';
                    card.style.transform = 'translateY(0)';
                }, index * 100);
            });
            
            // Unobserve after animation
            sectionObserver.unobserve(section);
        }
    });
}, observerOptions);

// Card hover effects observer
const cardObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const card = entry.target;
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
        }
    });
}, {
    root: null,
    rootMargin: '50px',
    threshold: 0.1
});

// Parallax scroll effect for hero shapes
let ticking = false;

function updateParallax() {
    const scrolled = window.pageYOffset;
    const rate = scrolled * -0.5;
    
    const shapes = document.querySelectorAll('.floating-shapes .shape');
    shapes.forEach((shape, index) => {
        const speed = 0.2 + (index * 0.1);
        shape.style.transform = `translateY(${rate * speed}px) rotate(${scrolled * 0.1}deg)`;
    });
    
    ticking = false;
}

function requestParallaxUpdate() {
    if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
    }
}

// Smooth scroll behavior for navigation
function smoothScrollTo(targetId) {
    const target = document.getElementById(targetId);
    if (target) {
        const headerHeight = 80;
        const targetPosition = target.offsetTop - headerHeight;
        
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
}

// Initialize animations
export function initScrollAnimations() {
    // Initialize sections
    const sections = document.querySelectorAll('section:not(.intro-section)');
    sections.forEach(section => {
        section.classList.add('section-animate');
        sectionObserver.observe(section);
    });
    
    // Initialize cards with initial hidden state
    const cards = document.querySelectorAll('.text-card, .project-card');
    cards.forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
    });
    
    // Initialize parallax
    if (window.innerWidth > 768) {
        window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    }
    
    // Add scroll-based header background change
    const header = document.querySelector('.fixed-header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 100) {
                header.style.background = 'rgba(23, 22, 22, 0.98)';
                header.style.backdropFilter = 'blur(20px)';
            } else {
                header.style.background = 'rgba(23, 22, 22, 0.95)';
                header.style.backdropFilter = 'blur(10px)';
            }
        }, { passive: true });
    }
    
    // Initialize contact form enhancements
    const form = document.querySelector('.contact-form');
    if (form) {
        const inputs = form.querySelectorAll('input, textarea, select');
        inputs.forEach(input => {
            input.addEventListener('focus', function() {
                this.parentElement.classList.add('focused');
            });
            
            input.addEventListener('blur', function() {
                if (!this.value) {
                    this.parentElement.classList.remove('focused');
                }
            });
        });
        
        // Form submission with loading state
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const submitBtn = form.querySelector('.submit-button');
            const originalText = submitBtn.innerHTML;
            
            submitBtn.innerHTML = '<span>Sending...</span>';
            submitBtn.disabled = true;
            
            // Simulate form submission (replace with actual submission logic)
            setTimeout(() => {
                submitBtn.innerHTML = '<span>Message Sent!</span>';
                setTimeout(() => {
                    submitBtn.innerHTML = originalText;
                    submitBtn.disabled = false;
                    form.reset();
                }, 2000);
            }, 1500);
        });
    }
}

// Cleanup function
export function cleanupScrollAnimations() {
    sectionObserver.disconnect();
    cardObserver.disconnect();
    window.removeEventListener('scroll', requestParallaxUpdate);
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initScrollAnimations);

// Export smooth scroll function for use in components
export { smoothScrollTo }; 